import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { ADVANCED_PLANS_APP_STEPS, APP_STEPS } from 'stores/App.store';
import { HeaderNavStepper } from '@wix/wix-ui-premium-purchase';
import { Text } from 'wix-style-react';
import s from './AppHeader.scss';
import { Template } from 'enums';
import {
  withExperiments,
  InjectedExperimentsProps,
} from '@wix/wix-experiments-react';

interface LoggedinHeaderStepsProps extends InjectedExperimentsProps {
  currentStep: number;
  changeStep(step: number): void;
}

const LoggedinHeaderStepsComp: React.FC<LoggedinHeaderStepsProps> = ({
  currentStep,
  changeStep,
}) => {
  const { t } = useTranslation();
  const { template, isFontUpgradeActive } = usePageModeContext();
  const steps =
    template === Template.Grid ? ADVANCED_PLANS_APP_STEPS : APP_STEPS;
  return (
    <HeaderNavStepper
      data-hook='nav-stepper'
      activeStep={currentStep}
      onStepClick={changeStep}
      fontUpgrade={isFontUpgradeActive}
    >
      {steps.map((stepTitle, index) => (
        <HeaderNavStepper.Step
          key={stepTitle}
          data-hook='nav-step'
          disabled={index > currentStep}
        >
          <Text size='small' className={s.stepText}>
            {t(stepTitle)}
          </Text>
        </HeaderNavStepper.Step>
      ))}
    </HeaderNavStepper>
  );
};

export const LoggedinHeaderSteps = withExperiments(LoggedinHeaderStepsComp);
